import { IGetAllResponse, IGetOneResponse } from '../Utilis/Types/Generic';
import { ApiService } from './ApiService';

export class TaskService extends ApiService {
  static pathName = 'task';

  static getTasks(): Promise<IGetAllResponse<any>> {
    return this.get(this.pathName);
  }

  static getSingleTask(id: string): Promise<IGetOneResponse<any>> {
    return this.get(this.pathName + '/' + id);
  }

  static getAdminSingleTask(
    taskId: string,
    userId: string
  ): Promise<IGetOneResponse<any>> {
    return this.get(this.pathName + `/${taskId}/user/${userId}`);
  }

  static submitAnswer(body: {
    answer: any;
    questionId: string;
  }): Promise<IGetOneResponse<any>> {
    return this.post(this.pathName + '/answer', body);
  }

  static duplicateQuestionsGroup(
    sectionId: string
  ): Promise<IGetOneResponse<any>> {
    return this.post(this.pathName + '/question-group', {
      questionsGroupId: sectionId,
    });
  }

  static removeQuestionsGroup(questionsGroupId: string) {
    return this.delete(this.pathName + '/question-group', {
      questionsGroupId,
    });
  }
}
